// 중앙정렬 푸터 copyright
export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer class="footer">© {year} 와이엠브릿지(YM Bridge). All rights reserved.</footer>
  );
}
